export function parseBrowserFamily(userAgent = '') {
  if (/EdgiOS\//.test(userAgent)) return 'Edge iOS';
  if (/SamsungBrowser\//.test(userAgent)) return 'Samsung Internet';
  if (/OPR\//.test(userAgent)) return 'Opera';
  if (/EdgA?\//.test(userAgent)) return 'Edge';
  if (/CriOS\//.test(userAgent)) return 'Chrome iOS';
  if (/Chrome\//.test(userAgent)) return 'Chrome';
  if (/Firefox\/|FxiOS\//.test(userAgent)) return 'Firefox';
  if (/Version\/[\d.]+.*Safari\//.test(userAgent)) return 'Safari';
  return 'Unknown';
}

export function parseClientMetadata() {
  if (typeof navigator === 'undefined') {
    return {
      browser: 'unknown',
      os: 'unknown',
      deviceType: 'unknown',
      userAgent: null,
      platform: null,
      language: null,
      languages: [],
      hardwareConcurrency: null,
      deviceMemoryGb: null,
      timezone: null,
      screen: null,
      connection: null,
    };
  }

  const userAgent = navigator.userAgent || '';
  const browser = parseBrowserFamily(userAgent).toLowerCase();

  let os = 'unknown';
  if (/Windows NT/.test(userAgent)) os = 'windows';
  else if (/Android/.test(userAgent)) os = 'android';
  else if (/iPhone|iPad|iPod/.test(userAgent)) os = 'ios';
  else if (/Mac OS X/.test(userAgent)) os = 'macos';
  else if (/Linux/.test(userAgent)) os = 'linux';

  let deviceType = 'desktop';
  if (/iPad|Tablet/.test(userAgent) || (/Android/.test(userAgent) && !/Mobi/.test(userAgent))) {
    deviceType = 'tablet';
  } else if (/Mobi|iPhone|iPod/.test(userAgent)) deviceType = 'mobile';

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  return {
    browser,
    os,
    deviceType,
    userAgent: userAgent || null,
    platform: navigator.platform || null,
    language: navigator.language || null,
    languages: Array.isArray(navigator.languages) ? navigator.languages : [],
    hardwareConcurrency: Number.isFinite(navigator.hardwareConcurrency)
      ? navigator.hardwareConcurrency
      : null,
    deviceMemoryGb: Number.isFinite(navigator.deviceMemory) ? navigator.deviceMemory : null,
    timezone,
    screen:
      typeof window !== 'undefined' && window.screen
        ? {
            width: window.screen.width || null,
            height: window.screen.height || null,
            pixelRatio: window.devicePixelRatio || 1,
          }
        : null,
    connection: connection
      ? {
          effectiveType: connection.effectiveType || null,
          downlinkMbps: Number.isFinite(connection.downlink) ? connection.downlink : null,
          rttMs: Number.isFinite(connection.rtt) ? connection.rtt : null,
          saveData: !!connection.saveData,
        }
      : null,
  };
}
